import type { SearchModes } from '@/domainLogic/index.ts';
import type { ProductsData } from '@/app/api/search/products/createProductsData.ts';
import type { JSX } from 'react';
import type { SearchParams } from '@/server/searchParams.ts';

export enum SuggestionsType {
  SELECTED = 'selected',
  REGULAR = 'regular',
  LEISURE = 'leisure',
  HOTEL = 'hotel',
  TRAIN = 'train',
}

export enum DateType {
  EXACT = 'exact',
  FLEX = 'flex',
  TIME = 'time',
  MONTHS = 'months',
  ANYTIME = 'anytime',
  WEEKEND = 'weekend',
}

export enum DatesType {
  CALENDAR = 'calendar',
  FLEXIBLE = 'flexible',
}

export type Dates = {
  departureDate: DateItem;
  returnDate: DateItem;
  flexDate: DateItem;
  subDate: number;
  type: DatesType;
};

export type DateItem = {
  subType?: DateType;
  type: DateType;
  dateTo?: string;
  dateFrom?: string;
  daysTo?: number;
  daysFrom?: number;
  months?: string[];
  date?: string;
};

export enum TagType {
  ANYWHERE = 'anywhere',
  CITY = 'city',
  CITY_BREAKS = 'citybreaks',
  COUNTRY = 'country',
  AIRPORT = 'airport',
  GEO = 'geo',
  BEACH = 'beach',
  EXOTIC = 'exotic',
  SKI = 'ski',
  SPA = 'spa',
  HOTEL = 'hotel',
  TRAIN_STATION = 'trainstation',
  TAG = 'tag',
}

export type SuggestionItem = {
  code: number | string;
  label?: string;
  labelShort?: string;
  tagType?: TagType;
  shift?: boolean;
  note?: string;
  rightNote?: string | JSX.Element;
  isLeisure?: boolean;
  cityCode?: string;
  countryCode?: string;
  countryName?: string;
  selected?: boolean;
  index: number;
  originIndex?: number;
  iconImage?: string;
  cityName?: string;
  originCityName?: string;
  locationName?: string;
  name?: string;
  imageUrl?: string;
};

export type RoomData = {
  adults: number;
  ages: number[];
};

export type PeopleData = RoomData[];

export type Suggestion = {
  title: string;
  suggestionItems: SuggestionItem[];
  suggestionsType: SuggestionsType;
};

export type DefaultDestItems = {
  searchMode: SearchModes;
  suggestions: Suggestion[];
};

// TODO: Can we get rid of this now?
export enum ReloadType {
  FILTER = 'FILTER',
  MAP = 'MAP',
  PAGING = 'PAGING',
  SEARCH = 'SEARCH',
  SORT = 'SORT',
}

export type HandleReloadDealsParams = {
  searchParams: SearchParams;
  reloadType: ReloadType;
  isWaitEnded?: boolean;
  isAlternativeDate?: boolean;
  responseData?: ProductsData;
  isListMode?: boolean;
};
